"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var browser_1 = require("@cian/config/browser");
var browser_2 = require("@cian/logger/browser");
var browser_3 = require("@cian/http-api/browser");
var setup_1 = require("./setup");
var vitals_1 = require("./vitals");
function init() {
    (0, browser_1.init)();
    (0, browser_2.init)();
    (0, browser_3.init)();
    (0, vitals_1.initWebVitals)();
    (0, setup_1.setupWebpackPublicPath)();
}
exports.init = init;
//# sourceMappingURL=interface.js.map